import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { formatNumber } from 'utils';

import styles from './index.module.css';

const NoOfJobsButton = ({ jobsCount, href, onClick, className }) => {
  const _onClick = () => {
    if (href) window.location.href = href;
  };
  return (
    <ZpButton
      theme="secondary"
      onClick={onClick || _onClick}
      className={classNames(styles.buttonLink, 'z-py-6', className)}
    >
      {formatNumber(jobsCount) + ' Jobs'}
    </ZpButton>
  );
};

NoOfJobsButton.propTypes = {
  jobsCount: PropTypes.number.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
NoOfJobsButton.defaultProps = {
  href: '',
};

export default NoOfJobsButton;
